// extracted by mini-css-extract-plugin
export default {"containerLogar":"LoginAviso_containerLogar__Wwb2N","form":"LoginAviso_form__GwofF"};